<audio
  #media
  [src]="resource.path | assets"
  (play)="onPlay()"
  (pause)="onPause()"
  (ended)="onEnd()"
  (timeupdate)="onTimeUpdate()"
  (loadedmetadata)="onLoadedMetadata()"
  (volumechange)="onVolumeChange()"></audio>

<div class="flex items-center space-x-2">
  <p-button
    text
    rounded
    [icon]="
      isMiniPlayer
        ? 'pi pi-arrow-down-left-and-arrow-up-right-to-center'
        : 'pi pi-arrow-up-right-and-arrow-down-left-from-center'
    "
    pTooltip="Toggle mini player"
    tooltipPosition="top"
    (onClick)="onToggleMiniPlayerClick()" />

  <p-splitbutton
    icon="pi pi-{{ isPlaying ? 'pause' : 'play' }}-circle"
    [label]="isPlaying ? 'Pause' : 'Play'"
    dropdownIcon="pi pi-cog"
    (onClick)="onTogglePlaybackClick()"
    [model]="actions" />
</div>

<p-dialog
  #popover
  [draggable]="false"
  [(visible)]="isMiniPlayer"
  position="bottomright"
  [style]="{
    width: '35rem',
  }">
  <div class="flex flex-col">
    <div class="flex items-center justify-center space-x-2">
      <p-button
        rounded
        raised
        severity="secondary"
        size="small"
        icon="pi pi-step-backward"
        pTooltip="Previous"
        (onClick)="onSeekBackwardClick()" />

      <p-button
        rounded
        raised
        severity="secondary"
        size="small"
        icon="pi pi-backward"
        pTooltip="Rewind 10s"
        (onClick)="onRewindClick()" />

      <p-button
        rounded
        raised
        size="large"
        [icon]="isPlaying ? 'pi pi-pause' : 'pi pi-play'"
        pTooltip="{{ isPlaying ? 'Pause' : 'Play' }}"
        (onClick)="onTogglePlaybackClick()" />

      <p-button
        rounded
        raised
        severity="secondary"
        size="small"
        icon="pi pi-forward"
        pTooltip="Forward 10s"
        (onClick)="onFastForwardClick()" />

      <p-button
        rounded
        raised
        severity="secondary"
        size="small"
        icon="pi pi-step-forward"
        pTooltip="Next"
        (onClick)="onSeekForwardClick()" />
    </div>

    <div class="my-12">
      <div class="flex items-center justify-between text-sm mb-3">
        <span>{{ currentTime | formatSecondsToMinutes }}</span>
        <span>{{ duration | formatSecondsToMinutes }}</span>
      </div>

      <div class="px-2">
        <p-slider
          [(ngModel)]="currentTime"
          [max]="duration"
          [step]="0.1"
          (onChange)="onSeek($event)" />
      </div>
    </div>

    <div class="flex items-center justify-between">
      <p-button
        rounded
        raised
        icon="pi pi-download"
        pTooltip="Download"
        (onClick)="onDownloadClick()" />
      <div class="flex items-center w-1/2 space-x-2">
        <p-button
          rounded
          raised
          severity="secondary"
          [icon]="isMuted ? 'pi pi-volume-off' : 'pi pi-volume-up'"
          pTooltip="{{ isMuted ? 'Unmute' : 'Mute' }}"
          (onClick)="onToggleMuteClick()" />
        <div class="grow px-2">
          <p-slider
            [(ngModel)]="volume"
            [max]="100"
            [step]="1"
            (onChange)="onVolumeSliderChange($event)" />
        </div>
      </div>
    </div>
  </div>
</p-dialog>
